// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%276%27 height=%2720%27 viewBox=%270 0 6 20%27 fill=%27black%27 opacity=%270.3%27 xmlns=%27http://www.w3.org/2000/svg%27><circle cx=%271%27 cy=%277%27 r=%271%27/><circle cx=%271%27 cy=%2713%27 r=%271%27/><circle cx=%271%27 cy=%2719%27 r=%271%27/><circle cx=%275%27 cy=%277%27 r=%271%27/><circle cx=%271%27 cy=%271%27 r=%271%27/><circle cx=%275%27 cy=%271%27 r=%271%27/><circle cx=%275%27 cy=%2713%27 r=%271%27/><circle cx=%275%27 cy=%2719%27 r=%271%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-table-header-cell {
  outline: none;
  padding: 0;
  border-bottom: 1px solid rgba(234, 234, 234, 1);
  border-bottom: 1px solid var(--component-grid-cell-bottom-border-color,rgba(234, 234, 234, 1));
}

.bolt-table-header-cell-text--required::after {
  content: " *";
  color: rgba(218, 10, 0, 1);
  color: var(--status-error-text,rgba(218, 10, 0, 1));
}

.bolt-table-header-border {
  border-bottom: 1px solid rgba(234, 234, 234, 1);
  border-bottom: 1px solid var(--component-grid-cell-bottom-border-color,rgba(234, 234, 234, 1));
}

.bolt-table-header-cell-content {
  border: 1px solid transparent;
  border-radius: 4px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  font-weight: 600;
  margin: 7px 0px;
  outline: none;
  padding: 0.375rem 0.6875rem;
  position: relative;
  text-align: left;
}
@media (forced-colors: active) {
  .bolt-table-header-cell-content {
    border-color: transparent;
  }
}

.bolt-table-header-cell-actionable > .bolt-table-header-cell-content {
  cursor: pointer;
}
.bolt-table-header-cell-actionable > .bolt-table-header-cell-content:hover {
  background-color: rgba(0, 0, 0, .02);
  background-color: var(--component-grid-row-hover-color,rgba(0, 0, 0, .02));
}

.bolt-focus-visible .bolt-table-header-cell-actionable:focus > .bolt-table-header-cell-content {
  background-color: rgba(222, 236, 249, 1);
  background-color: var(--component-grid-selected-row-color,rgba(222, 236, 249, 1));
}

.bolt-table-header-cell-empty:hover {
  background-color: inherit;
}

.bolt-table-header-sort-icon {
  padding: 0 4px;
}

.bolt-table-header-sizer {
  bottom: 0px;
  position: absolute;
  right: 0px;
  top: 0px;
}

.bolt-table-header-row.focused .bolt-table-cell-content-reveal,
.bolt-table-header-row:hover .bolt-table-cell-content-reveal,
.bolt-table-row.focused .bolt-table-cell-content-reveal,
.bolt-table-row:hover .bolt-table-cell-content-reveal {
  visibility: visible;
}

.bolt-table-two-line-cell-item {
  padding: 1px;
}
.bolt-table-two-line-cell-item .bolt-table-link:focus {
  animation: focus-shadow-pulse-inset 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-table-two-line-cell-item .bolt-table-link:focus {
    animation: none;
  }
}
.bolt-table-two-line-cell-item .bolt-table-link:focus {
  box-shadow: inset 0 0 0 3px rgba(0, 120, 212, 0.23), inset 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: inset 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), inset 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}

.bolt-table-two-line-cell-icon {
  margin-right: 12px;
}

.bolt-table-cell-compact {
  padding: 0px;
}

.bolt-table-show-lines .bolt-table-row:not(.first-row) .bolt-table-cell {
  border-top: 1px solid rgba(234, 234, 234, 1);
  border-top: 1px solid var(--component-grid-cell-bottom-border-color,rgba(234, 234, 234, 1));
}

.bolt-table-cell-primary {
  font-weight: 600;
}

.bolt-table-cell-tertiary {
  color: rgba(0, 0, 0, 0.55); /* @TODO: What color to use for a light color. */
}

.justify-cell-start .bolt-list-cell-child {
  justify-content: flex-start;
}

.justify-cell-end .bolt-list-cell-child {
  justify-content: flex-end;
}

.bolt-table-cell-content {
  padding: 0.5625rem 0.75rem;
}
.bolt-table-cell-content .bolt-list-cell-child:not(:last-child) {
  margin-right: 4px;
}
.bolt-table-cell-content .bolt-list-cell-text {
  flex-grow: 1;
  overflow: hidden;
}

.bolt-table-cell-content-with-link {
  padding: 0.375rem 0.375rem;
}

.bolt-table-cell-content-with-inline-link {
  padding: 0.375rem 0.5rem;
}

.bolt-table-cell-content-with-button {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.bolt-table-inline-link-left-padding {
  padding-left: 0.25rem;
}

.bolt-table-inline-link-right-padding {
  padding-right: 0.25rem;
}

.bolt-table-link.bolt-link {
  padding: 0.1875rem 0.375rem;
  color: inherit;
  border-radius: 4px;
}
.bolt-table-link.bolt-link:focus, .bolt-table-link.bolt-link:active {
  outline: none;
}
.bolt-table-link.bolt-link:hover {
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}

.bolt-table-inline-link.bolt-table-link {
  padding: 0.1875rem 0.25rem;
}

.bolt-table-cell-content-reveal {
  visibility: hidden;
}
@media screen and (max-width: 599px) {
  .bolt-table-cell-content-reveal {
    visibility: visible;
  }
}

.bolt-table-cell-select .bolt-table-header-cell-content:hover {
  background-color: inherit;
}

.bolt-table-cell-select {
  padding: 2px 0px 0px 0px;
  font-weight: normal;
}

.bolt-table-spacer-cell {
  z-index: 1;
}

.bolt-gripper-container {
  margin-left: 5px;
  width: 0.625rem;
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

.bolt-gripper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 1.25rem;
  width: 0.625rem;
}

.bolt-focus-visible .bolt-table-header-cell:focus > .bolt-table-header-cell-content {
  animation: ms-focus-shadow-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-table-header-cell:focus > .bolt-table-header-cell-content {
    animation: none;
  }
}
.bolt-focus-visible .bolt-table-header-cell:focus > .bolt-table-header-cell-content {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
  z-index: 1;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-table-header-cell:focus > .bolt-table-header-cell-content {
    border: 3px solid highlight;
    forced-color-adjust: none;
    background: transparent;
    color: windowtext;
  }
}

.bolt-focus-visible .bolt-table .bolt-list-row:focus .bolt-list-cell {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
}

.bolt-focus-visible .bolt-table-link:focus {
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}

.bolt-focus-visible .bolt-table-header-sizer:focus {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--communication-background,rgba(0, 120, 212, 1));
}

.bolt-table-container.sticky-table {
  display: inline-block;
  overflow: auto;
}

.bolt-table.sticky-table th {
  position: -webkit-sticky;
  position: sticky;
  background: rgba(255, 255, 255, 1);
  background: var(--background-color,rgba(255, 255, 255, 1));
  top: 0;
  z-index: 9;
}

/*# sourceMappingURL=Table.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Table/Table.scss","webpack://./../azure-devops-ui/bin/Components/Table/Table.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/_widgetsCommon.scss"],"names":[],"mappings":"AAUA;EACI,aAAA;EACA,UAAA;EACA,+CAAA;ECTF,8FAA8F;AAChG;;AAEA;EDYQ,aEoMY;ED9MlB,0BAA0B;EAC1B,mDAAmD;ADarD;;ACVA;EACE,+CAA+C;EDajD,8FAAA;ACXA;;AAEA;EDaI,6BEsQiB;EFrQjB,kBAAA;EACA,yBAAA;EACA,qDAAA;EACA,gBAAA;EACA,eAAA;ECXF,aAAa;EEsBX,2BAAA;EHpBJ,kBAAA;ECCE,gBDWM;ACVR;AACA;EACE;IDYF,yBAAA;EACI;ACVJ;;AAEA;EACE,eAAe;AACjB;ADaA;EACI,oCIlDoB;EHuCtB,0EAA0E;AAC5E;;AAEA;EACE,wCAAwC;EACxC,iFAAiF;ADanF;;ACVA;EACE,yBAAyB;ADa3B;;ACVA;EDaI,cAAA;ACXJ;;AAEA;EDaA,WAAA;EAAA,kBAAA;EAAA,UAAA;EAAA,QAAA;ACRA;;AAEA;;;;EDgBI,mBAAA;ACXJ;;AEtBI;EHiCA,YAAA;ACPJ;AACA;EACE,2DAA2D;ADKzD;ACHJ;EACE;IACE,eAAe;EDMnB;ACJA;AACA;EACE,yFAAyF;EDM3F,gJAAA;ACJA;;AAEA;EDMA,kBAAA;ACJA;;AAEA;EDMA,YAAA;ACJA;;AAEA;EDMA,4CAAA;EACI,2FAAA;ACJJ;;ADOA;EACI,gBAAA;ACJJ;;ADOA;EACI,0BAAA,EAAA,gDAAA;ACJJ;;ADOA;EACI,2BAAA;ACJJ;;AAEA;EACE,yBAAyB;ADOvB;;ACJJ;EACE,0BAA0B;AAC5B;ADUA;EACI,iBAAA;ACRJ;AACA;EDYA,YAAA;EACI,gBAAA;ACVJ;;ADeA;EACI,0BAAA;ACZJ;;AAEA;EDcA,wBAAA;ACZA;;AAEA;EDcA,qBAAA;EACI,wBA9ImC;ACkIvC;;ADiBA;EACI,qBAAA;ACdJ;;AAEA;EDiBI,sBAAA;ACfJ;;ADoBI;EACI,2BEnJmB;EFoJnB,cAAA;ECjBN,kBAAkB;AACpB;ADuBA;EACI,aAAA;ACrBJ;AACA;EDyBA,0BAAA;EACI,0DAAA;ECvBF,qCAAqC;ECiMnC,kEAAA;AD/LJ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;ADwBA;EACI;IACA,mBE0Fe;EDhHjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EDwBI,wBAAA;EAEA,mBAAA;ACvBJ;;AAEA;EACE,UAAU;AACZ;;AAEA;EDyBI,gBAAA;EACA,eAAA;ECvBF,YAAY,EAAE,2CAA2C;EACzD,YAAY;EDyBd,iBAAA;EGhKQ,oBAAA;AF0IR;;AAEA;EACE,yDEzIM;EF0IN,eAAe;EACf,eAAe;ADiBjB;;ACdA;EDkBI,wDAAA;AChBJ;AE/JI;EH2KJ;IAOQ,eAAA;ECfN;AACF;AACA;EACE,6CAA6C;EAC7C,0EAA0E;EAC1E,kCAAkC;EDiBpC,2EAAA;EACI,UAAA;ACfJ;AACA;EDkBI;IACI,2BE1NmB;IF2NnB,yBE9GU;ID8Fd,uBAAuB;IACvB,iBAAiB;EDoBjB;AClBJ;;AAEA;EDqBA,kCAAA;EACI,2EAAA;ACnBJ;;AAEA;EDqBA,0BAAA;EACI,0DAAA;EACA,qCAAA;EAEA,kEEzGc;ADqFlB;;AAEA;EACE,sCAAsC;EACtC,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;EAClC,0DAA0D;EAC1D,MAAM;EACN,UAAU;AACZ;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
